import { useEffect, useState } from 'react';
import cleanLocalStorage from 'modules/clean-local-storage/clean-local-storage';
import { useHistory } from 'react-router-dom';
import { Card, Container, Dimmer, Loader } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { emptyStore } from 'redux/actions/feed-store-actions';

export default function LogoutPage() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      cleanLocalStorage();
      dispatch(emptyStore());
      history.push('/login');
    } catch (error) {
      console.error(error);
      setLoading(false);
      history.push('/login');
    }
  }, [loading, setLoading, history, dispatch]);

  return (
    <Container fluid>
      <Card fluid>
        <Dimmer.Dimmable>
          <Dimmer active={loading} inverted>
            <Loader style={{ marginTop: 100 }}>Redirigiendo…</Loader>
          </Dimmer>
        </Dimmer.Dimmable>
      </Card>
    </Container>
  );
}
